var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleMapsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92.3 132.3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60.2 2.2c-4.4-1.4-9.2-2.2-14.1-2.2-14.1 0-26.8 6.4-35.3 16.5l21.8 18.3z",
    fill: "#1a73e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.8 16.5c-6.7 8-10.8 18.4-10.8 29.6 0 8.7 1.7 15.7 4.6 22l28-33.3z",
    fill: "#ea4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m46.2 28.5c9.8 0 17.7 7.9 17.7 17.7 0 4.3-1.6 8.3-4.2 11.4 0 0 13.9-16.6 27.5-32.7-5.6-10.8-15.3-19-27-22.7l-27.6 32.6c3.3-3.8 8.1-6.3 13.6-6.3",
    fill: "#4285f4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m46.2 63.8c-9.8 0-17.7-7.9-17.7-17.7 0-4.3 1.5-8.3 4.1-11.3l-28 33.3c4.8 10.6 12.8 19.2 21 29.9l34.1-40.5c-3.3 3.9-8.1 6.3-13.5 6.3",
    fill: "#fbbc04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m59.1 109.2c15.4-24.1 33.3-35 33.3-63 0-7.7-1.9-14.9-5.2-21.3l-61.6 73.1c2.6 3.4 5.3 7.3 7.9 11.3 9.4 14.5 6.8 23.1 12.8 23.1s3.4-8.7 12.8-23.2",
    fill: "#34a853"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsLogo);
export default __webpack_public_path__ + "static/media/google_maps_logo.e5fa737d4e3a21422eaddb68ab8d9678.svg";
export { ForwardRef as ReactComponent };